import { render } from "./LetterForm.vue?vue&type=template&id=0972f516"
import script from "./LetterForm.vue?vue&type=script&lang=js"
export * from "./LetterForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__